import {KeycloakConfig} from 'keycloak-js';

import keycloakConfigDefaults from './keycloak_config.json';

const runtimeEnv = typeof window !== 'undefined' ? window.__MERIE_ENV__ : undefined;

const keycloakConfig: KeycloakConfig = {
  realm: runtimeEnv?.KEYCLOAK_REALM || keycloakConfigDefaults.realm,
  url: runtimeEnv?.KEYCLOAK_URL || keycloakConfigDefaults.url,
  clientId: runtimeEnv?.KEYCLOAK_CLIENT_ID || keycloakConfigDefaults.clientId,
};

export default keycloakConfig;
